<button class="{{ prevArrowSelector }}" [disabled]="prevArrowDisabled" (click)="slidePrev()" pButton>
  <fa-icon [icon]="prevIcon"></fa-icon>
</button>

@if (dates?.length > 0) {
  <swiper-container #swiper ushSwiperElement [config]="swiperConfig" init="false">
    <swiper-slide *ngFor="let date of dates">
      <ush-ui-date [date]="date" (dateSelected)="onItemSelected(date)"></ush-ui-date>
    </swiper-slide>
  </swiper-container>
} @else if (hours?.length > 0) {
  <swiper-container #swiper ushSwiperElement [config]="swiperConfig" init="false">
    <swiper-slide *ngFor="let hour of hours">
      <ush-ui-hour [hour]="hour" (hourSelected)="onItemSelected(hour)"></ush-ui-hour>
    </swiper-slide>
  </swiper-container>
} @else {
  <p i18n="@@dates-carousel.noDatesAvailable">No dates or hours available</p>
}

<button
  class="{{ nextArrowSelector }}"
  [disabled]="nextArrowDisabled"
  (click)="slideNext()"
  pButton
  [attr.aria-label]="swiperConfig?.a11y?.nextSlideMessage"
  [attr.data-translate-aria-label]="'next-slide'"
>
  <fa-icon [icon]="nextIcon"></fa-icon>
</button>
